import React from 'react';
import { TableFooter } from '../components/TableFooter';
import {
  useFasterPayoutsQuery,
  useFasterPayoutsQueryPagerProps,
} from '../../hooks/faster-payouts/queries';
import { FasterPayoutsTableContent } from './FasterPayoutsTableContent';

export const FasterPayoutsTable = () => {
  const props = useFasterPayoutsQueryPagerProps();
  return (
    <>
      <React.Suspense fallback={null}>
        <FasterPayoutsTableContent useQuery={useFasterPayoutsQuery} />
      </React.Suspense>
      <React.Suspense fallback={null}>
        <TableFooter paginationProps={props} />
      </React.Suspense>
    </>
  );
};

export default FasterPayoutsTable;
